import {
  NestedBubbleCircle,
  NestedBubbleCircleBorder,
  NestedBubbleHeader,
  NestedBubbleMetadata,
  NestedBubbleText,
} from '@/components/public/Visualisations/NestedBubbles'
import { Shapes } from '@/components/public/Visualisations/types'

export class NestedBubble {
  private _metadata: NestedBubbleMetadata
  private _addShapeToCanvasFunc: Function
  private _shapes: Record<string, Shapes.Shape> = {}

  constructor(metadata: NestedBubbleMetadata, addShapeToCanvasFunc: Function) {
    this._metadata = metadata
    this._addShapeToCanvasFunc = addShapeToCanvasFunc
  }

  get visNode() {
    return this._metadata.visNode
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get level() {
    return this._metadata.level
  }

  updateAppearance(
    isSelectedOfAncestorOfSelected: boolean,
    maxDisplayLevel: number,
    filterLuminosity: number,
    userZoomScale: number,
  ) {
    const visible = isSelectedOfAncestorOfSelected || this.level <= maxDisplayLevel
    this._metadata.maxDisplayLevel = maxDisplayLevel
    this._metadata.filterLuminosity = filterLuminosity
    this._metadata.userZoomScale = userZoomScale
    this.updateShapeAppearance('circle', visible, () => new NestedBubbleCircle(this._metadata))
    this.updateShapeAppearance(
      'border',
      visible,
      () => new NestedBubbleCircleBorder(this._metadata),
    )
    this.updateShapeAppearance(
      'header',
      visible && this.level < maxDisplayLevel,
      () => new NestedBubbleHeader(this._metadata),
    )
    this.updateShapeAppearance(
      'text',
      visible && this.level >= maxDisplayLevel,
      () => new NestedBubbleText(this._metadata),
    )
  }

  private updateShapeAppearance(
    shapeName: string,
    visible: boolean,
    createShapeFunc: () => Shapes.Shape,
  ) {
    let shape = this._shapes[shapeName]

    if (visible) {
      if (!shape) {
        shape = createShapeFunc()
        this._addShapeToCanvasFunc(shape)
        this._shapes[shapeName] = shape
      }
      shape.visible(true)
      shape.refresh()
    } else {
      shape?.visible(false)
    }
  }
}
